import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentActionsMenuSkillSelected.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type UseTrackAgentActionsMenuSkillSelectedParams = {
  skill_id: string;
  via_search: boolean;
};

export const useTrackAgentActionsMenuSkillSelected = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentActionsMenuSkillSelected = useCallback(
    (params: UseTrackAgentActionsMenuSkillSelectedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentActionsMenuSkillSelected };
};
